
import { User } from '@/models/main';
import { JBStopDates } from '@/models/jbAdvanced';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Button from '@/components/UI/button/Button.vue';

import { mapState } from 'vuex';
import { format, utcToZonedTime } from 'date-fns-tz';
import { timeZoneDefault } from '@/utils/PortalConstants';
import { generateDayTimesAmPm, formatDateStringWithTZ } from '@/utils/InputProcessingUtilities';

@Component({
  components: {
    Button,
  },
  computed: {
    ...mapState('moduleUser', { user: 'user' }),
  },
})
export default class DeliveryDetails extends Vue {
  @Prop(Number) private stop: number;
  @Prop(Number) private stops_counter: number;
  @Prop(Boolean) private warehouse: boolean;
  @Prop(Array) private dateTimes: JBStopDates[];

  private user!: User;

  private timeArray: string[][] = [];
  private timeToArray: string[][] = [];
  private menu = [];

  private today = '';

  private defaultSelectorClicked = [false, false, false];

  private tabItemsCount = 6;
  private tabItemsPrevCount = 22;

  public todayClick(stop: number): void {
    const userTimeZone = this.user.timezone || timeZoneDefault;
    const nowMil = utcToZonedTime(new Date(), userTimeZone).getTime();
    // Look for a time slot:
    const roundedMil = Math.round(nowMil / 1000 / 60 / 30) * 30 * 60 * 1000;
    const todayTime = format(new Date(roundedMil), 'hh:mm aa');
    const nextTimeIdx = this.timeArray[stop].indexOf(todayTime) + 1;
    const todayDate = format(utcToZonedTime(new Date(), userTimeZone), 'yyyy-MM-dd');
    // Set the time starting from the 1st stop
    // Corner case: late time (ex: 11:00 PM on the 1st stop – no slots for 2nd)
    for (let i = 0; i < this.dateTimes.length; i++) {
      this.dateTimes[i].timeFrom = todayTime;
      this.dateTimes[i].timeTo = this.timeArray[i][nextTimeIdx];
      this.dateTimes[i].date = todayDate;
      this.dateTimes[i].dateFormatted = todayDate;
      this.dateTimes[i].timeIsSetted = true;
    }
  }

  private completionArrayTime(): void {
    this.timeArray[0] = generateDayTimesAmPm(30);
    this.timeArray[1] = [...this.timeArray[0]];
    this.timeArray[2] = [...this.timeArray[0]];
    this.timeToArray = [...this.timeArray];
  }

  private defaultSelectorClick(value: string, stop: number): void {
    this.dateTimes[stop].timeIsSetted = true;
    this.defaultSelectorClicked[stop] = true;
    if (value === 'AM') {
      this.dateTimes[stop].timeFrom = '09:00 AM';
      this.dateTimes[stop].timeTo = '12:00 PM';
    }
    if (value === 'PM') {
      this.dateTimes[stop].timeFrom = '12:00 PM';
      this.dateTimes[stop].timeTo = '05:00 PM';
    }
  }

  private timeChanged(stop: number): void {
    this.defaultSelectorClicked[stop] = false;
  }

  @Watch('dateTimes', { deep: true })
  private watchToDateTimes(): void {
    this.dateTimes.map((date, i) => {
      this.dateTimes[i].dateFormatted = formatDateStringWithTZ(
        date.date,
        this.user.timezone || timeZoneDefault,
        'yyyy-MM-dd',
      );
    });

    let stop2TimeOptions = [...this.timeArray[0]];

    if (this.dateTimes[0] && this.dateTimes[1] && this.dateTimes[1].date === this.dateTimes[0].date) {
      const stop1timeFromIndex = this.timeArray[0].indexOf(this.dateTimes[0].timeFrom);
      const stop2timeFromIndex = this.timeArray[0].indexOf(this.dateTimes[1].timeFrom);
      const nextTime = this.timeArray[0][stop1timeFromIndex + 1];

      if (stop1timeFromIndex >= stop2timeFromIndex) {
        this.dateTimes[1].timeFrom = nextTime;
      }
      if (stop1timeFromIndex > 0) {
        const filteredTimes = [...this.timeArray[0]];
        filteredTimes.splice(0, stop1timeFromIndex + 1);
        stop2TimeOptions = [...filteredTimes];
      }
    }

    let stop3TimeOptions = [...this.timeArray[0]];

    if (this.dateTimes[1] && this.dateTimes[2] && this.dateTimes[2].date === this.dateTimes[1].date) {
      const stop2timeFromIndex = stop2TimeOptions.indexOf(this.dateTimes[1].timeFrom);
      const stop3timeFromIndex = stop2TimeOptions.indexOf(this.dateTimes[2].timeFrom);
      const nextTime = stop2TimeOptions[stop2timeFromIndex + 1];
      if (stop2timeFromIndex >= stop3timeFromIndex || stop2timeFromIndex === -1) {
        this.dateTimes[2].timeFrom = nextTime;
      }
      if (stop2timeFromIndex > -1) {
        const filteredTimes = [...stop2TimeOptions];
        filteredTimes.splice(0, stop2timeFromIndex + 1);
        stop3TimeOptions = [...filteredTimes];
      }
    }

    this.timeArray = [this.timeArray[0], stop2TimeOptions, stop3TimeOptions];

    const finalTimeToArray = this.dateTimes.map((date, idx) => {
      const timeFromIdx = this.timeArray[idx].indexOf(date.timeFrom);
      const timeToOptions = [...this.timeArray[idx]];
      timeToOptions.splice(0, timeFromIdx + 1);

      if (this.timeArray[idx].indexOf(date.timeTo) <= this.timeArray[idx].indexOf(date.timeFrom)) {
        this.dateTimes[idx].timeTo = timeToOptions[0];
      }

      return timeToOptions;
    });
    this.timeToArray = finalTimeToArray;

    this.$emit('changeDates', this.dateTimes);
  }

  private created(): void {
    const userTimeZone = this.user.timezone || timeZoneDefault;
    this.today = format(utcToZonedTime(new Date(), userTimeZone), 'yyyy-MM-dd'); // today
  }

  private mounted(): void {
    this.completionArrayTime();
  }
}
